export default "__VITE_ASSET__DcnkXcuE__"